<div class="connect-home h-100 d-flex align-items-center justify-content-center">
  <div class="connect-bg-container fender" [class.demo]="returnto && returnto.indexOf('studioonedemo') > -1">
    @if (fenderProductCallout || ssoType == "fender") {
      <div class="video-background">
        <video autoplay loop muted playsinline>
          <source [src]="'https://studioone-content-r2.presonusmusic.com/videos/mustangmicropplus.webm'" type="video/webm" />
        </video>
      </div>
    }
    <!-- <div class="video-background">
    <video autoplay loop muted playsinline>
      <source
        [src]="fenderProductCallout ? 'https://studioone-content-r2.presonusmusic.com/videos/mustangmicropplus.webm' : 'https://studioone-content-r2.presonusmusic.com/videos/loopingmadkeys20.webm'"
        type="video/webm"
        />
    </video>
  </div> -->
  </div>
  <div class="connect-ui-container">
    <div class="connect-login-container" data-cy="connect-login-container">
      @if (appService.app != "fender") {
        @if (!returnto || (returnto.indexOf("signup") == -1 && returnto.indexOf("join") == -1 && returnto.indexOf("studioonedemo") == -1 && !fenderProductCallout && ssoType != "fender")) {
          <img
            class="login-logo"
            [src]="themeImage == 'plainlight' || (themeImage == 'auto' && appService.systemTheme == 'light') ? './assets/images/presonus_logo_black.png' : './assets/images/presonus_logo.png'"
          />
        }
        @if (returnto && (returnto.indexOf("signup") > -1 || returnto.indexOf("join") > -1) && !fenderProductCallout && ssoType != "fender") {
          <img
            class="login-logo"
            [src]="themeImage == 'plainlight' || (themeImage == 'auto' && appService.systemTheme == 'light') ? './assets/images/s1plus-logo-black.png' : './assets/images/s1plus-logo-white.png'"
          />
        }
        @if (returnto && returnto.indexOf("studioonedemo") > -1) {
          <img
            class="login-logo-demo"
            [src]="
              themeImage == 'plainlight' || (themeImage == 'auto' && appService.systemTheme == 'light') ? './assets/images/sop7-demo-logo-lightbg.png' : './assets/images/sop7-demo-logo-darkbg.png'
            "
          />
        }
        @if (fenderProductCallout && ssoType != "fender") {
          <img
            class="login-logo"
            [src]="
              themeImage == 'plainlight' || (themeImage == 'auto' && appService.systemTheme == 'light')
                ? './assets/images/mustangmicro-register-black.svg'
                : './assets/images//mustangmicro-register-white.svg'
            "
          />
        }
      }

      @if (ssoType == "fender") {
        <div>
          <img class="login-logo" src="./assets/images/fender-logo-red.png" alt="Fender logo" />
        </div>
      }
      @if (appService.app == "fender") {
        <div class="m-b-20">
          <div class="d-flex justify-content-center align-items-center">
            <myp-svg id="fender-logo" class="svg-brand-color" width="120" height="70"></myp-svg>
            <div class="m-x-20">&bull;</div>
            <myp-svg id="presonus-logo" class="svg-neutral" width="120" height="70"></myp-svg>
          </div>
          @if (displayedAuthSection != "Sign Up" && shouldShowPresonusFenderMessage) {
            <div class="m-y-10 t-14">
              {{ "login_updates.use_existing_login" | translate }}
            </div>
          }
        </div>
      }
      @if (loadingCredentials) {
        <div class="input-container">
          <myp-inline-loader [loading]="loadingCredentials" height="200px" spinnerName="loadingCredentials"></myp-inline-loader>
        </div>
      }
      @if (!loadingCredentials) {
        @if (returnto && returnto.indexOf("studioonedemo") > -1) {
          <div class="brandfont-black bold text-center m-y-20">
            @if (shouldShowS17Demo) {
              <img src="./assets/images/studio-one-pro-7-demo-box-landscape.png" class="w-100 m-b-40" style="max-width: 400px; margin-left: auto; margin-right: auto" alt="" />
              <br />
              <h5>Sign in or create an account to download and activate your 30-day demo of Studio One Pro 7.</h5>
            }
            @if (!shouldShowS17Demo) {
              The Studio One Pro 7 demo is coming soon.
            }
          </div>
        }
        @if (fenderProductCallout) {
          <div class="brandfont-black bold text-center m-y-20">Your Fender product includes access to {{ env.studioOnePlusBrandName }}. To redeem, sign in or create an account below.</div>
        }
        @if (returnto && returnto.indexOf("buy") > -1) {
          <div class="brandfont-black bold text-center m-y-20">
            <img src="./assets/images/studio-one-7-box-screen.png" class="w-100 m-b-40" style="max-width: 250px; margin-left: auto; margin-right: auto" alt="" />
            <br />
            Sign in or create an account to continue with your purchase of Studio One.
          </div>
        }
        @if (returnto && (returnto.indexOf("signup") > -1 || returnto.indexOf("join") > -1)) {
          <div class="brandfont-black bold text-center m-y-20">
            To proceed with subscribing to {{ env.studioOnePlusBrandName }},
            <br />
            please sign in or create an account.
          </div>
        }
        @if (ssoType && ssoDestinations[ssoType] && ssoType && ssoDestinations[ssoType].message) {
          <div class="brandfont-black bold text-center m-y-20">
            {{ ssoDestinations[ssoType].message }}
          </div>
        }
        @if (productSplash?.preregistrationCustomUI) {
          <div class="brandfont-black bold text-center m-y-20">
            @if (productSplash?.preregistrationCustomUI?.title) {
              <div class="brandfont-black h2 m-b-20 t-20">{{ productSplash.preregistrationCustomUI.title }}</div>
            }
            @if (productSplash?.preregistrationCustomUI?.imageUrl) {
              <img [src]="productSplash.preregistrationCustomUI.imageUrl" class="w-100 m-b-40" style="max-width: 400px; margin-left: auto; margin-right: auto" />
            }
            @if (productSplash?.preregistrationCustomUI?.blurb) {
              <div class="brandfont">{{ productSplash.preregistrationCustomUI.blurb }}</div>
            }
          </div>
        }
        @if (!loggedInUser && !needsVerification) {
          <div class="input-container">
            @if (!isEmployeeEmail || ssoType != "zendesk") {
              <myp-segmented-bar [white]="true" (selected)="displayAuthSection($event.name)" [options]="authSections"></myp-segmented-bar>
            }
            @if (displayedAuthSection == "Sign Up") {
              <div class="double-input">
                <input
                  [disabled]="loading"
                  type="text"
                  class="login-input"
                  data-cy="first-name-input"
                  (keyup.enter)="displayedAuthSection == 'Sign Up' ? signUp() : signIn()"
                  (keyup)="onKeyUp($event)"
                  [(ngModel)]="first_name"
                  [placeholder]="'profile.edit.first_name' | translate"
                />
                <input
                  [disabled]="loading"
                  type="text"
                  class="login-input"
                  data-cy="last-name-input"
                  (keyup.enter)="displayedAuthSection == 'Sign Up' ? signUp() : signIn()"
                  (keyup)="onKeyUp($event)"
                  [(ngModel)]="last_name"
                  [placeholder]="'profile.edit.last_name' | translate"
                />
              </div>
            }
            <div class="single-input">
              <input
                [disabled]="loading"
                type="email"
                (blur)="emailBlur()"
                (focus)="emailFocus()"
                class="login-input"
                data-cy="email-input"
                (keyup.enter)="displayedAuthSection == 'Sign Up' ? signUp() : signIn()"
                (keyup)="onKeyUp($event)"
                [(ngModel)]="email"
                [placeholder]="'profile.edit.email' | translate"
                [ngClass]="!emailPasses && email ? 'invalid' : ''"
              />
              <!-- <ng-container *ngIf="env.developer_email && displayedAuthSection == 'Sign Up'">
            <span class="link" (click)="generateEmail()">Generate</span>
          </ng-container> -->
            </div>
            @if (displayedAuthSection == "Sign Up") {
              <div class="single-input country-input" (click)="showCountrySelector()">
                <input type="text" disabled="true" class="login-input" data-cy="country-input" [(ngModel)]="selectedCountry.name" placeholder="Choose your country." />
                <div class="flag">
                  <img [src]="'https://flagcdn.com/28x21/' + selectedCountry.code.toLowerCase() + '.png'" />
                </div>
              </div>
            }
            @if (!isEmployeeEmail || ssoType != "zendesk") {
              <div class="password-input">
                <input
                  [disabled]="loading"
                  [type]="passwordVisible ? 'text' : 'password'"
                  class="login-input"
                  data-cy="password-input"
                  (keyup.enter)="displayedAuthSection == 'Sign Up' ? signUp() : signIn()"
                  (keyup)="onKeyUp($event)"
                  maxlength="24"
                  [(ngModel)]="password"
                  [placeholder]="'login.enter_password' | translate"
                  style="padding-right: 60px"
                />
                <fa-icon [icon]="passwordVisible ? 'eye-slash' : 'eye'" (click)="passwordVisible = !passwordVisible" class="password-icon"></fa-icon>
              </div>
            }
            @if (displayedAuthSection == "Sign Up") {
              <div class="m-b-20 d-flex align-items-center">
                @if (passwordPasses) {
                  <fa-icon icon="check-circle" class="t-16 m-r-5 c-green"></fa-icon>
                }
                <span class="t-12">{{ "profile.password_min" | translate }}</span>
              </div>
            }
            @if (displayedAuthSection == "Sign Up" && showV2Captcha) {
              <div class="captcha d-flex justify-content-center">
                <re-captcha (resolved)="resolved($event)" siteKey="{{ env.reCaptchaKey }}"></re-captcha>
              </div>
            }
            @if (displayedAuthSection == "Sign Up" && appService.app == "fender") {
              <div class="position-relative">
                <div class="multi-select-input" mode="button" (click)="showMultiSelectOptions = !showMultiSelectOptions; $event.stopPropagation()">
                  <div class="d-flex align-items-center justify-content-between">
                    @if (!selectedSignupInterestsArray.length) {
                      <span class="text-muted">Choose your interests...</span>
                    }
                    @if (selectedSignupInterestsArray.length) {
                      <span>
                        @for (interest of selectedSignupInterestsArray; track interest; let i = $index) {
                          <span class="t-12">
                            {{ ("com.skills." + interest.string_id | translate) + (i < selectedSignupInterestsArray.length - 1 ? ", " : "") }}
                          </span>
                        }
                      </span>
                    }
                    <fa-icon [icon]="showMultiSelectOptions ? 'chevron-up' : 'chevron-down'" class="t-16 m-l-5"></fa-icon>
                  </div>
                </div>
                @if (showMultiSelectOptions) {
                  <div class="multi-select-options animate-in-down" (clickOutside)="showMultiSelectOptions = false">
                    @for (interest of signupInterests; track interest) {
                      <div class="multi-select-option" mode="button" [class.selected]="selectedSignupInterests[interest.string_id]" (click)="selectSignupInterest(interest)">
                        <span>{{ "com.skills." + interest.string_id | translate }}</span>
                        <fa-icon
                          [icon]="selectedSignupInterests[interest.string_id] ? 'check-circle' : 'circle'"
                          class="t-16 m-l-5"
                          [class.c-green]="selectedSignupInterests[interest.string_id]"
                        ></fa-icon>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (loginError) {
              <div class="login-error">{{ loginError }}</div>
            }
            @if (displayedAuthSection == "Sign Up") {
              <div class="m-b-20 m-t-20 text-left">
                <div class="d-flex align-items-center m-y-20">
                  <myp-switch [active]="wantsEmail" (toggle)="wantsEmail = !wantsEmail"></myp-switch>
                  <label class="m-l-10 t-12 form-check-label" for="wantsEmail">{{ "login.like_receive_offers" | translate }}</label>
                </div>
              </div>
            }
            @if (isEmployeeEmail && ssoType == "zendesk") {
              <button class="brand-btn w-full" (click)="zendeskRedirect()">
                <span>Click to Login to Zendesk</span>
              </button>
            }
            @if (!isEmployeeEmail || ssoType != "zendesk") {
              <button
                [disabled]="loading || (displayedAuthSection == 'Sign Up' && (!emailPasses || !password))"
                class="brand-btn w-full"
                data-cy="login-signup-button"
                [class.disabled]="loading || (displayedAuthSection == 'Sign Up' && (!emailPasses || !password))"
                (click)="displayedAuthSection == 'Sign Up' ? signUp() : signIn()"
              >
                @if (!loading) {
                  <span>{{ (displayedAuthSection == "Sign Up" ? "login.create_account" : "login.login") | translate }}</span>
                }
                @if (loading) {
                  <fa-icon icon="spinner" class="button" [animation]="'spin'"></fa-icon>
                }
              </button>
            }

            <div class="m-t-20 d-flex justify-content-between">
              <button type="button" class="btn btn-secondary flex-grow-1 p-y-20 d-flex justify-content-center" (click)="signInWithGoogle()">
                <myp-svg id="google-logo" class="svg-white" width="20" height="20"></myp-svg>
              </button>
              <button type="button" class="btn btn-secondary flex-grow-1 m-l-20 p-y-20 d-flex justify-content-center" (click)="signInWithFacebook()">
                <myp-svg id="facebook-logo" class="svg-white" width="20" height="20"></myp-svg>
              </button>
              <button type="button" class="btn btn-secondary flex-grow-1 m-l-20 p-y-20 d-flex justify-content-center" (click)="signInWithApple()">
                <myp-svg id="apple-logo" class="svg-white" width="20" height="20"></myp-svg>
              </button>
            </div>

            <div class="text-center m-t-20">
              <span class="link bold t-12" data-cy="forgot-password-link" (click)="startForgotPassword()">{{ "profile.forgot_password" | translate }}</span>
            </div>
            @if (productSplash?.preregistrationCustomUI?.allowSkipRegistration) {
              <div class="text-center m-t-20">
                <span class="link bold t-12" (click)="skipStraightToSplash()">Skip This Step</span>
              </div>
            }
            <div class="language pointer d-flex justify-content-center m-t-30" tabindex="0" (keyup.enter)="appService.showLanguageChooser()" (click)="appService.showLanguageChooser()">
              <img class="d-inline" [src]="helperService.selectedLanguage.flag_icon" style="width: 20px; height: 15px" />
            </div>
            <div class="t-12 text-center m-t-50">
              <span [innerHTML]="'login.terms_agree' | translate: { url: 'https://www.fender.com/terms-of-use' }"></span>
            </div>
          </div>
        }
        @if (!loggedInUser && needsVerification) {
          <div class="text-center input-container">
            A code has been sent to your email, please copy and paste it below.
            <input [disabled]="loading" class="login-input m-y-20" data-cy="verify-code-input" (keyup.enter)="verify()" [(ngModel)]="verificationCode" [placeholder]="'Enter the code you received.'" />
            <button [disabled]="loading" class="brand-btn w-full" data-cy="verify-code-button" (click)="verify()">
              @if (!loading) {
                <span>Verify Code</span>
              }
              @if (loading) {
                <fa-icon icon="spinner" class="button" [animation]="'spin'"></fa-icon>
              }
            </button>
            <div class="text-center m-t-20">
              <span class="link bold t-12 c-white" (click)="resendCode()">Resend Code</span>
            </div>
          </div>
        }
        @if (loggedInUser) {
          <div class="text-center input-container">
            <span class="text-muted">Logged in as</span>
            <br />
            <br />
            <img [src]="user.photoURL || './assets/images/default_avatar.jpg'" class="generic-profile-photo d-inline-block m-b-10" />
            @if (user.firstName && user.lastName) {
              <div class="t-20 bold m-b-20">
                {{ user.firstName + " " + user.lastName }}
              </div>
            }
            @if (!user.firstName || !user.lastName) {
              <div class="t-20 bold m-b-20">
                {{ user.email }}
              </div>
            }
            @if (needsVerification) {
              @if (!codeSent) {
                Please verify your email.
                <br />
                <br />
                <button [disabled]="loading" class="brand-btn w-full" (click)="resendCode()">
                  @if (!loading) {
                    <span>Send Code</span>
                  }
                </button>
              }
              @if (codeSent) {
                A code has been sent to your email, please copy and paste it below.
                <input [disabled]="loading" class="login-input m-y-20" (keyup.enter)="verify()" [(ngModel)]="verificationCode" [placeholder]="'Enter the code you received.'" />
                <button [disabled]="loading" class="brand-btn w-full" (click)="verify()">
                  @if (!loading) {
                    <span>Verify Code</span>
                  }
                  @if (loading) {
                    <fa-icon icon="spinner" class="button" [animation]="'spin'"></fa-icon>
                  }
                </button>
                <div class="text-center m-t-20">
                  <span class="link bold t-12 c-white" (click)="resendCode()">Resend Code</span>
                </div>
              }
            }
            @if (!needsVerification) {
              <div class="m-y-10">
                @if (ssoType && ssoDestinations[ssoType] && ssoType != "zendesk") {
                  <a (click)="initSso()" class="btn btn-primary m-b-20">{{ "Continue to " + ssoDestinations[ssoType].title }}</a>
                }
                @if (ssoType && ssoType == "zendesk") {
                  <button class="btn btn-primary m-b-20" (click)="zendeskRedirect()">
                    <span>Click to Login to Zendesk</span>
                  </button>
                }
              </div>
              @if (!ssoType || ssoType != "fender") {
                <a (click)="goToMypresonus()" class="btn small-btn blank m-b-20">{{ "onboarding.go_sphere" | translate }}</a>
              }
            }
            <br />
            <br />
            <span (click)="logout()" class="btn small-btn red">Log Out</span>
          </div>
        }
      }
    </div>
  </div>
</div>
